// extracted by mini-css-extract-plugin
module.exports = {"dialog_header":"DialogHeader_dialog_header__xwdVp","main_information":"DialogHeader_main_information__3cnVN"};